import React from 'react';
import { Modal, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const ErrorModal = ({ open, onClose, error }) => (
  <Modal open={open} onClose={onClose} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
    <Box sx={{ width: "90%", maxWidth: 500, bgcolor: "background.paper", borderRadius: 2, boxShadow: 3, p: 2 }}>
      <div className="modal-header" style={{ background: "red", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2 style={{ margin: 0, padding: 10 }}>Error</h2>
        <IconButton onClick={onClose} color="inherit" data-log="Close Icon Button"><CloseIcon /></IconButton>
      </div>
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", width: "100%" }}>
        <p style={{ color: "black", fontSize: 20, margin: 20 }}>{ error || error?.message}</p>
      </div>
    </Box>
  </Modal>
);

export default ErrorModal;